import { Component, OnInit, EventEmitter, Output, ElementRef, ViewChild, Input, ChangeDetectionStrategy, ChangeDetectorRef } from '@angular/core';
import { MapComponent } from '../map/map.component';
import { SLMap } from 'src/app/model/sl-map';

// @ts-ignore
import { LngLatBounds } from '!mapbox-gl';
import { toMercator } from '@turf/projection';
import * as turf from '@turf/turf';
import { MapDataAction } from 'src/app/model/map-actions/map_data-action';
import { ModalMessagerService } from 'src/app/modal-messager/modal-messager.service';
import * as Packer from 'zip-stream';
@Component({
  selector: 'app-image-capture-panel',
  templateUrl: './image-capture-panel.component.html',
  styleUrls: ['./image-capture-panel.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ImageCapturePanelComponent implements OnInit {

  public name = 'Map Image Capture';
  public imageSrc = '';
  public previewImage = '';
  public downloadName = 'MapImage';
  public output = '';
  public projURL = '';
  public mapIsOrientedNorth = false;
  map: SLMap;
  @Output() change = new EventEmitter<any>();
  @ViewChild('imageLink') imageLink: ElementRef;
  @ViewChild('worldFileLink') worldFileLink: ElementRef;
  @ViewChild('prjFileLink') prjFileLink: ElementRef;
  @ViewChild('auxFileLink') auxFileLink: ElementRef;
  private _backless: 'true' | 'false';
  @Input() set backless(isBackless: 'true' | 'false') {
    this._backless = isBackless;
  }
  get isBackless(): boolean {
    return this._backless === 'true';
  }
  constructor(private messager: ModalMessagerService, private cdr: ChangeDetectorRef) {

  }

  ngOnInit(): void {

  }
  Back() {
    if (this.map && this.map.component) {
      MapDataAction.CloseCapture(this.map.component, {});
    }
    this.change.emit({ target: this, action: 'back' });

  }
  Capture(map?: SLMap) {
    if (!map) {
      if (!this.map) return;
    }
    this.map = map;
    this.downloadName = map.project.name;
    this.mapIsOrientedNorth = false;
    this.imageSrc = this.map.ui.getCanvas().toDataURL();
    if (map.ui.getBearing() === 0) {
      if (map.ui.getPitch() === 0) {
        this.mapIsOrientedNorth = true;
      }
    }
    this.Refresh();
  }
  ToWorldFile(map: SLMap) {
    const canvas = map.ui.getCanvas();
    const canvasWidth = canvas.width;
    const canvasHeight = canvas.height;

    const bottomLeft = map.ui.unproject([0, canvasHeight]); // bounds.getSouthWest();
    const SWMercator = turf.toMercator(turf.point([bottomLeft.lng, bottomLeft.lat]));
    const topRight = map.ui.unproject([canvasWidth - 1, 0]); //bounds.getNorthEast();
    const NEMercator = turf.toMercator(turf.point([topRight.lng, topRight.lat]));
    const minX = SWMercator.geometry.coordinates[0];
    const minY = SWMercator.geometry.coordinates[1];
    const maxX = NEMercator.geometry.coordinates[0];
    const maxY = NEMercator.geometry.coordinates[1];
    const pixelSizeX = Math.abs(maxX - minX) / canvasWidth;
    const pixelSizeY = Math.abs(maxY - minY) / canvasHeight;
    const startX = minX + 1.5 * (pixelSizeX / 2.0);
    const startY = maxY - (pixelSizeY / 2.0);

    const worldFileContent = `${pixelSizeX}\n0\n0\n${-pixelSizeY}\n${minX}\n${maxY}`;

    this.output = worldFileContent;
    return this.output;
  }
  ToWorldFileOld(map) {
    // This version does not use the conversion to actual projection units and instead is using lon lat
    // coordinates. This seems to create a more consistent output when the resulting image is imported
    // and the CRS is set to EPSG: 3857 (Pseudo Mercator); At least this is true for QGIS.
    const mapComponent: MapComponent = map.component;

    const pxWidth = mapComponent.mapContainer.nativeElement.offsetWidth;
    const pxHeight = mapComponent.mapContainer.nativeElement.offsetHeight;

    const mapUI: mapboxgl.Map = map.ui;
    const bounds: LngLatBounds = map.ui.getBounds();
    const SW = map.ui.unproject([0, pxHeight]); // bounds.getSouthWest();
    const SWMercator = turf.toMercator(turf.point([SW.lng, SW.lat]));
    const NE = map.ui.unproject([pxWidth - 1, 0]); //bounds.getNorthEast();
    const NEMercator = turf.toMercator(turf.point([NE.lng, NE.lat]));

    const minX = SWMercator.geometry.coordinates[0];
    const minY = SWMercator.geometry.coordinates[1];
    const maxX = NEMercator.geometry.coordinates[0];
    const maxY = NEMercator.geometry.coordinates[1];


    // A = units per pixel in X-direction
    const dX = (maxX - minX);
    const pxSizeX = dX / (pxWidth - 1);
    // D = units per per pixel in the Y direction
    const dY = (maxY - minY);
    const pxSizeY = dY / (pxHeight - 1);
    // E = Center of first pixel's X coordinate in map units
    const startPixelCenterX = minX;// + (pxSizeX / 2.0);
    // F = Center of first pixel's Y coordinate in map units
    const startPixelCenterY = maxY;// - (pxSizeY / 2.0);

    // Line 1: units per pixel in x direction
    this.output = '' + pxSizeX;
    // Line 2: x axis rotation, always 0
    this.AddLine(0);
    // Line 3: y axis rotation, always 0
    this.AddLine(0);
    // Line 4: units per pixel (negative) in the y direction
    this.AddLine(-pxSizeY);
    // Line 5: x coordinate of center of starting pixel;
    this.AddLine(startPixelCenterX);
    // Line 6: y coordinate of center of starting pixel;
    this.AddLine(startPixelCenterY);
    return this.output;
    // Note: a "pixel" for line 5 and 6 is referring more to a pixel sized pxSizeX by pxSizeY and not necessarily a screen coordinate.

    // convert output to blob and object url for use in achnor tag href
  }
  DownloadEverything() {
    const payLoad: any = {}
    payLoad.defaultFileName = this.map.project.name
    payLoad.image = {
      extension: 'png',
      mimeType: ' ',
      contents: this.imageSrc,
      defaultFileName: this.map.project.name
    };
    const pgw = this.ToWorldFile(this.map);
    payLoad.world = {
      extension: 'pgw',
      mimeType: 'text/plain',
      contents: pgw,
      defaultFileName: this.map.project.name
    }
    const proj = 'PROJCS["WGS_1984_Web_Mercator_Auxiliary_Sphere",GEOGCS["GCS_WGS_1984",DATUM["D_WGS_1984",SPHEROID["WGS_1984",6378137.0,298.257223563]],PRIMEM["Greenwich",0.0],UNIT["Degree",0.017453292519943295]],PROJECTION["Mercator_Auxiliary_Sphere"],PARAMETER["False_Easting",0.0],PARAMETER["False_Northing",0.0],PARAMETER["Central_Meridian",0.0],PARAMETER["Standard_Parallel_1",0.0],PARAMETER["Auxiliary_Sphere_Type",0.0],UNIT["Meter",1.0]]';

    payLoad.prj = {
      extension: 'prj',
      mimeType: 'text/plain',
      contents: proj,
      defaultFileName: this.map.project.name,
    }
    const aux = `<PAMDataset><SRS>${proj}</SRS></PAMDataset>`;
    payLoad.aux = {
      extension: 'png.aux.xml',
      mimeType: 'text/plain',
      contents: aux,
      defaultFileName: this.map.project.name
    }
    this.messager.RequestCompressedExport(
      payLoad,
      'Export map image and associated files');
  }
  DownloadImage() {
    this.messager.RequestExport(
      {
        extension: 'png',
        mimeType: ' ',
        contents: this.imageSrc,
        defaultFileName: this.map.project.name
      }, 'Export map image'
    );
  }
  DownloadWorldFile() {
    const pgw = this.ToWorldFile(this.map);
    this.messager.RequestExport(
      {
        extension: 'pgw',
        mimeType: 'text/plain',
        contents: pgw,
        defaultFileName: this.map.project.name
      }, 'Export world file'
    );
  }
  DownloadProjectionFile() {
    const proj = 'PROJCS["WGS_1984_Web_Mercator_Auxiliary_Sphere",GEOGCS["GCS_WGS_1984",DATUM["D_WGS_1984",SPHEROID["WGS_1984",6378137.0,298.257223563]],PRIMEM["Greenwich",0.0],UNIT["Degree",0.017453292519943295]],PROJECTION["Mercator_Auxiliary_Sphere"],PARAMETER["False_Easting",0.0],PARAMETER["False_Northing",0.0],PARAMETER["Central_Meridian",0.0],PARAMETER["Standard_Parallel_1",0.0],PARAMETER["Auxiliary_Sphere_Type",0.0],UNIT["Meter",1.0]]';

    this.messager.RequestExport(
      {
        extension: 'prj',
        mimeType: 'text/plain',
        contents: proj,
        defaultFileName: this.map.project.name,
      }, 'Export ESRI Projection file.'
    );
  }
  DownloadAuxFile() {
    const aux = '<PAMDataset><SRS>PROJCS["WGS_1984_Web_Mercator_Auxiliary_Sphere",GEOGCS["GCS_WGS_1984",DATUM["D_WGS_1984",SPHEROID["WGS_1984",6378137.0,298.257223563]],PRIMEM["Greenwich",0.0],UNIT["Degree",0.017453292519943295]],PROJECTION["Mercator_Auxiliary_Sphere"],PARAMETER["False_Easting",0.0],PARAMETER["False_Northing",0.0],PARAMETER["Central_Meridian",0.0],PARAMETER["Standard_Parallel_1",0.0],PARAMETER["Auxiliary_Sphere_Type",0.0],UNIT["Meter",1.0]]</SRS></PAMDataset>';
    this.messager.RequestExport(
      {
        extension: 'png.aux.xml',
        mimeType: 'text/plain',
        contents: aux,
        defaultFileName: this.map.project.name
      }, 'Export Auxiliary file.  Note: This file should be saved as aux.xml. However, the browser may pre-pend the file with an underscore (e.x. _aux.xml) on Windows operating systems. To work with your image you will need to remove the underscore after download.'
    );
  }


  private AddLine(newLine) {
    this.output += '\n' + newLine;
    this.Refresh();
  }
  Refresh() {
    this.cdr.detectChanges();
  }

}
